export const en = {
  loading: "Loading...",
  retry: "Retry",
  cancel: "Cancel",
  continue: "Continue",
  back: "Back",
  next: "Next",
  emptyStateTitle: "There are no items in your cart",
  unknownProduct: "Unknown Product",
  productImageAlt: "Product Image",
  emptyStateDescription:
    "Looks like your cart is empty. Start adding some items to get started!",

  checkout: "Checkout",
  orderSummary: "Order Summary",
  total: "Total",
  subtotal: "Subtotal",
  tax: "Tax",
  taxAmount: "Tax Amount",
  discount: "Discount",
  agreeToTerms: "I agree to",
  termsAndConditionsLink: "terms and conditions",
  depositAmount: "Deposit Amount",
  fee: "Fee",
  amountToBePaid: "Amount to Pay",

  payment: "Payment",
  paymentMethod: "Payment Method",
  cardNumber: "Card Number",
  expiryDate: "Expiry Date",
  cvv: "CVV",

  orderConfirmed: "Order Confirmed",
  orderNumber: "Order Number",
  thankYou: "Thank you for your order!",

  required: "This field is required",
  invalidEmail: "Please enter a valid email address",
  invalidPhone: "Please enter a valid phone number",
  invalidCard: "Please enter a valid card number",
  termsRequired:
    "You must accept the terms and conditions to complete your order",

  paymentMethods: {
    creditCard: "Credit Card",
    applePay: "Apple Pay",
    cashOnDelivery: "Cash on Delivery",
    bankTransfer: "Bank Transfer",
    tamara: "Tamara",
    tabby: "Tabby",
    noMethodsAvailable: "No payment methods are currently available.",
    payLater: "Pay Later",
    confirmBooking: "Confirm Booking",
    confirmSubscription: "Confirm Subscription",
    completeOrder: "Complete Order"
  },

  bankTransfer: {
    noAccountsAvailable: "No bank accounts available",
    contactSupport: "Please contact support to set up bank transfer payments",
    selectBank: "Select Bank Account",
    loadingAccounts: "Loading bank accounts...",
    transferDetails: "Transfer Details",
    bankName: "Bank Name",
    holderName: "Account Holder Name",
    accountNumber: "Account Number",
    iban: "IBAN",
    transferorName: "Transferor Name",
    transferorNamePlaceholder: "Enter your name exactly as shown in your bank account",
    uploadReceipt: "Upload Transfer Receipt",
    error: {
      title: "Unable to load bank accounts",
      generic: "Please try again later"
    }
  },

  bank: {
    1: "Saudi National Bank",
    2: "Saudi Awwal Bank",
    3: "Saudi Investment Bank",
    4: "Alinma Bank",
    5: "Banque Saudi Fransi",
    6: "Riyad Bank",
    7: "Al Rajhi Bank",
    8: "Arab National Bank",
    9: "Bank Al Bilad",
    10: "Bank Aljazira",
    11: "Gulf International Bank"
  },

  text: {
    copied: "{{ label }} copied to clipboard",
    copyFailed: "Failed to copy to clipboard"
  },

  discountCode: {
    label: "Discount code",
    apply: "Apply",
    placeholder: "Enter discount code",
    remove: "Remove",
    applied: "Discount applied"
  },

  paymentForm: {
    secureEncrypted: "All transactions are secure and encrypted.",
    cardNumberPlaceholder: "Card number",
    expiryDatePlaceholder: "Expiration date (MM / YY)",
    securityCodePlaceholder: "Security code",
    nameOnCardPlaceholder: "Name on card",
    accountHolderPlaceholder: "Account holder name",
    selectBank: "Select Bank",
    chooseBankPlaceholder: "Choose your bank",
    dropImageHere: "Drop the image here",
    dragDropText: "Drag & drop an image here, or click to select",
    fileFormats: "PNG, JPG, GIF up to 10MB",
    clickToReplace: "Click or drag to replace",
    tamaraDescription: "Split into 4 payments, no interest",
    tabbyDescription: "Pay in full or in installments",
    secureNote: "Secure and encrypted",
    processing: "Processing...",
    payNow: "Pay now",
    bookingNotes: "Order Notes",
    bookingNotesPlaceholder: "Order Notes (Optional)",
    cashOnDeliveryNote: "You will pay when your order is delivered.",
    invalidCreditCard: "Please enter valid credit card information",
    quickPayment: "Quick Payment",
    or: "or"
  },
  upload: {
    error: {
      maxFileUpload: "You can upload a maximum of {{ maxFileCount }} file.",
      invalidFileType:
        "Unsupported file type. Please upload an image in PNG, JPG, or GIF format.",
      singleFileUpload: "Please upload one file only"
    }
  },
  creditCardForm: {
    emptyCardNumber: "Card number is required.",
    invalidCardNumber: "The card number you entered is invalid.",
    emptyExpiryDate: "Expiry date is required.",
    monthOutOfRange: "Expiry month must be between 01 and 12.",
    yearOutOfRange: "Expiry year cannot be in the past.",
    dateOutOfRange: "The expiry date cannot be in the past.",
    invalidExpiryDate: "The expiry date you entered is invalid.",
    emptyCVC: "CVC is required.",
    invalidCVC: "The CVC you entered is invalid.",
    invalidZipCode: "The ZIP code you entered is invalid.",
    cardExpired: "This card has expired.",
    nameOnCardPlaceholder: "Full Name as it appears on card",
    cardNumberPlaceholder: "Card Number",
    expiryDatePlaceholder: "Expiration date (MM / YY)",
    securityCodePlaceholder: "Security code",
    nameRequired: "Name is required",
    nameMinLength: "Length of name of less than 2 characters",
    nameInvalidChars: "Name contains invalid characters"
  },

  error: {
    title: "Something Went Wrong",
    paymentFailed: "Payment Failed",
    generic: "Please try again later"
  },

  creditCardValidations: {
    cardNumberRequired: "Card number is required",
    cardNumberLength: "Card number must be between 13 and 19 digits",
    cardNumberInvalid: "Please enter a valid card number",

    nameOnCardRequired: "Name on card is required",
    nameOnCardMinLength: "Name must be at least 2 characters",
    nameOnCardInvalid:
      "Name can only contain letters, spaces, dots, and hyphens",

    expiryMonthRequired: "Expiry month is required",
    expiryMonthInvalid: "Please enter a valid month (MM)",

    expiryYearRequired: "Expiry year is required",
    expiryYearInvalid: "Please enter a valid year (YY)",

    cvcRequired: "CVC is required",
    cvcInvalid: "Please enter a valid CVC (3 or 4 digits)",

    cardExpired: "This card has expired",
    transferorNameRequired: "Transferor name is required",
    transferorNameMinLength: "Transferor name must be at least 2 characters",

    bankReceiptRequired: "Please upload a bank receipt",

    phoneNumberInvalid: "Please enter a valid phone number",

    couponCodeRequired: "Coupon code is required",
    couponCodeMinLength: "Coupon code cannot be empty",
    couponCodeMaxLength: "Coupon code must be less than 50 characters",

    acceptTOS: "You must accept the terms and conditions",
    termsAndConditions: "Terms and conditions",
    close: "close"
  }
} as const;
